const image = { height: 579, src: '/storybook/card-property-image@3x.jpg', width: 870 };

// ---------------------------------------------------------

export default {
  props: {
    button: {
      label: 'Update Notifications'
    },
    checkboxes: {
      items: [
        {
          label: 'Price change'
        },
        {
          label: 'Status change'
        },
        {
          label: 'An open house scheduled'
        }
      ],
      selectAllLabel: null
    },
    heading: 'Notify me when this listing has:',
    property: {
      image: image,
      property: {
        address: '1059 Celestial St',
        city: 'Mt. Adams',
        price: '$204,000',
        realtor: {
          isActiveSibcyAgent: true,
          name: 'Ruby Jameson',
          url: '/ruby-jameson'
        },
        state: 'OH'
      }
    },
    url: '/'
  }
};
